import React, { useEffect, useState } from "react";
import { toISO } from "@store/disponibiliteStore";
import { HOURS_START, HOURS_END } from "./gridTypes";

/** Heure courante en heures décimales, rafraîchie chaque minute. */
function useNowHour(): { date: string; hour: number } {
  const read = () => {
    const d = new Date();
    return { date: toISO(d), hour: d.getHours() + d.getMinutes() / 60 };
  };
  const [now, setNow] = useState(read);
  useEffect(() => {
    const id = window.setInterval(() => setNow(read()), 60_000);
    return () => window.clearInterval(id);
  }, []);
  return now;
}

/**
 * Curseur horaire rouge (comme MyO) : trait horizontal à l'heure actuelle, affiché
 * seulement sur la date du jour et dans la plage de la grille. Au-dessus des aimants
 * posés (z 10–20), sous le fantôme de glisser-déposer (35–40) ; ne capte aucun clic.
 */
export default function NowLine({
  date,
  hourBlockHeight,
  left,
  width,
}: {
  date: string;
  hourBlockHeight: number;
  left: number | string;
  width?: string;
}) {
  const now = useNowHour();
  if (date !== now.date || now.hour < HOURS_START || now.hour >= HOURS_END) return null;
  const top = (now.hour - HOURS_START) * hourBlockHeight;
  return (
    <div
      className="absolute pointer-events-none"
      style={{ top: top - 1, left, ...(width ? { width } : { right: 0 }), height: 2, background: "#EF4444", zIndex: 25 }}
    >
      <div
        className="absolute rounded-full"
        style={{ left: -4, top: -3, width: 8, height: 8, background: "#EF4444" }}
      />
    </div>
  );
}
